<template>
  <div class="adBox" >
    <van-row gutter="5">
      <van-col span="2" v-if="$root.adList && $root.adList.icoAd" v-for="item in $root.adList.icoAd" :key="item.id">
        <a :href="item.url">
          <img :src="item.imgUrl" class="icoAdImg">
          <div class="icoTitle">
            {{item.title}}
          </div>
        </a>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  name: "icoAd"
}
</script>
